import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCarrotIconWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 29,
	height: 51,
	viewBox: "0 0 29 51",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.622 40.953l2.37-1.918-3.97.076-4.923-5.656 3.698-2.578-5.278.664-5.348-6.006 5.082-2.813-6.135 1.257L.903 19.25l27.286-6.93v7.585l-5.736 3.372 5.736-.796v8.678l-2.959 1.923 2.96-.091v6.737l-2.01 1.747 2.01.16c0 5.691-.055 8.715-.164 9.071-.723.89-8.404-9.753-8.404-9.753zM17.629 0c.616 0-2.364 4.303-1.853 7.879 1.97-1.439 4.18-3.822 7.738-3.822 1.6 0-2.14 1.888-3.653 3.822-1.78 2.276-1.968 5.119-2.118 5.158-1.36.36-5.174 1.418-6.472 1.688-.455.096-.308-.913-.754-1.564-.446-.652-9.534-5.864-7.828-6.304 2.138-.551 5.942 1.313 8.703 1.892C12.4 4.057 15.582 0 17.629 0z",
		fill: "#FFF",
		fillRule: "evenodd"
	})
});
export default SvgCarrotIconWhite;
